import React from 'react'
import { parseQuery } from "../../../../../../base/hooks/useQueryString";
import Icon from '../../../../../../base/components/Icon';
import {SORT_KEY, SORT_TYPE} from "../../../../../../base/constants/query";
import {ROLE_IN_LEAGUE_LABEL} from "../../../../../../base/constants/users";

const DESC_SORT = 'desc';
const DESC_SORT_ICON = 'sortDesc';
const ASC_SORT_ICON = 'sortAsc';
const SORT_DEFAULT_ICON = 'sortDefault';

export default function LeaguesTableStructure(location, decorateText) {
    const infoQuery = parseQuery(location.search);
    function getSortIcon(cellName) {
        if (infoQuery[SORT_KEY] === cellName) {
            return infoQuery[SORT_TYPE] === DESC_SORT ? ASC_SORT_ICON : DESC_SORT_ICON;
        }
        return SORT_DEFAULT_ICON;
    }

    return [
        {
            dataField: "leagueName",
            sort: true,
            headerFormatter: () => (<>League name<Icon icon={getSortIcon('leagueName')} /></>),
            formatter: (cellContent, league) => {
                return (
                    <section className="d-flex flex-row align-items-center">
                        <span className="tutee-list--list__name teams-table__name" {...decorateText(league.leagueName)} />
                    </section>
                )
            }
        },
        {
            dataField: "leagueType",
            sort: true,
            headerFormatter: () => (<>League type<Icon icon={getSortIcon('leagueType')} /></>),
            formatter: (cellContent, league) => {
                return (
                    <section className="d-flex flex-row align-items-center">
                        <span className="tutee-list--list__name"  {...decorateText(league.leagueType)} />
                    </section>
                )
            }
        },
        {
            dataField: "roleInLeague",
            sort: true,
            headerFormatter: () => (<>Role in the League <Icon icon={getSortIcon('roleInLeague')} /></>),
            formatter: (cellContent, league) => {
                return <span {...decorateText(ROLE_IN_LEAGUE_LABEL[league.roleInLeague])} />
            }
        }
    ]
}